var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("SummaryReport.BasicInfo.Location.Title")))
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t("SummaryReport.BasicInfo.Location.Selection.Municipality")
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "SummaryReport.BasicInfo.Municipalities.Title_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(_vm.$t("SummaryReport.BasicInfo.Location.Selection.Region"))
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(_vm.$t("SummaryReport.BasicInfo.Regions.Title_Instructions"))
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(_vm.$t("SummaryReport.BasicInfo.Location.Selection.Abroad"))
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "SummaryReport.BasicInfo.Location.Selection.Abroad_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t("SummaryReport.BasicInfo.Location.Selection.Nationwide")
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "SummaryReport.BasicInfo.Location.Selection.Nationwide_Instructions"
              )
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "SummaryReport.BasicInfo.Location.Selection.WellbeingServiceCounty"
              )
            )
          )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t(
                "SummaryReport.BasicInfo.WellbeingServiceCounties.Title_Instructions"
              )
            )
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(_vm._s(_vm.$t("SummaryReport.BasicInfo.PersonnelResources")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ml-3" }, [
      _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))]),
      _vm._v(" "),
      _c("p", { staticClass: "question" }, [
        _vm._v(
          _vm._s(
            _vm.$t("SummaryReport.BasicInfo.PersonnelResources_Description")
          )
        )
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _c("p", { staticClass: "question" }, [
      _vm._v(
        _vm._s(_vm.$t("SummaryReport.BasicInfo.AdditionalInformation.Title"))
      )
    ]),
    _vm._v(" "),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.$t(
            "SummaryReport.BasicInfo.AdditionalInformation.Title_Instructions"
          )
        )
      )
    ]),
    _vm._v(" "),
    _c("ul", [
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(_vm.$t("SummaryReport.BasicInfo.AdditionalInformation.Name"))
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t("SummaryReport.BasicInfo.AdditionalInformation.Email")
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("li", [
        _c("b", [
          _vm._v(
            _vm._s(
              _vm.$t("SummaryReport.BasicInfo.AdditionalInformation.Phone")
            )
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }